import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { PresentationComponent } from './presentation/presentation.component';
import { NosServicesComponent } from './nos-services/nos-services.component';
import { ReservationComponent } from './reservation/reservation.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ArticleService } from './blog/blog-services/article.service';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PartenairesComponent } from './partenaires/partenaires.component';
import { ListAvisComponent } from './avis/list-avis/list-avis.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ItemAvisComponent } from './avis/item-avis/item-avis.component';
import { AvisService } from './services/avis.service';
import { BlogModule } from './blog/blog.module';
import { ContactService } from './contact/contact-services/contact.service';
import { ContactModule } from './contact/contact.module';
import { BackOfficeComponent } from './back-office/back-office.component';
import { AuthModule } from './auth/auth.module';
import { AuthGuard } from './auth/auth-services/auth-guard.service';
import { MapComponent } from './components/map/map.component';
import { ListArticlesComponent } from './blog/list-articles/list-articles.component';


@NgModule({
    // Les classes de vues (Composants, Directives et Pipes)
    declarations: [			
        AppComponent,
        HomeComponent,
        PresentationComponent,
        NosServicesComponent,
        ReservationComponent,
        ListAvisComponent,
        PageNotFoundComponent,
        HeaderComponent,
        FooterComponent,
        PartenairesComponent,
        ItemAvisComponent,
        BackOfficeComponent,
        MapComponent,
    ],
    // classes nécessaires à ce mudule
    imports: [
        BrowserModule,
        BlogModule,
        ContactModule,
        AuthModule,
        AppRoutingModule,
        ReactiveFormsModule
    ],
    // sous-ensemble de classes de vues visible depuis d'autres modules
    exports: [
        RouterModule,
        MapComponent
    ],
    // Fournir les services utilisés
    providers: [
        ArticleService,
        AvisService,
        ContactService,
        AuthGuard
    ],
    // uniquement sur le module racine, il permet d'indiquer le composant racine
    bootstrap: [AppComponent]
})
export class AppModule { }
